import { EyeIcon } from '@heroicons/react/16/solid';

import { Chip, Tooltip } from '@cavela/ui';

import { Typography } from '../ui';

/**
 * Row styling for table rows that only impersonating staff can see: an amber
 * tint plus a left stripe, so they stand out from what the customer sees.
 * Pair it with `StaffOnlyTag` in one of the row's cells to explain the tint.
 *
 * `!` is needed to win over the `.heroui-table tbody tr` hover background, and
 * the padding is scoped under `.heroui-table` so it outranks that table's
 * `td:first-child { !px-0 }` rule — otherwise the text sits on the stripe.
 */
export const STAFF_ONLY_ROW_CLASSNAME =
  '!bg-yellow-light-4 hover:!bg-yellow-light-3 [&>td:first-child]:shadow-[inset_4px_0_0_var(--color-yellow-dark)] [.heroui-table_&>td:first-child]:!pl-3';

/** Labels a record that is hidden from the customer and only visible to impersonating staff. */
const StaffOnlyTag: React.FC = () => {
  return (
    <Tooltip
      closeDelay={0}
      className="rounded-lg shadow-md font-medium text-base"
      content="Only visible to staff while impersonating. The customer doesn't see this."
    >
      <Chip
        color="default"
        className="bg-yellow-light-3 border border-yellow-light rounded-lg !px-[6px] !h-6"
        classNames={{ content: '!p-0 flex items-center gap-1' }}
      >
        <EyeIcon className="size-3.5 text-yellow-dark-2" />
        <Typography variant="body-3" className="text-yellow-dark-2">
          Staff only
        </Typography>
      </Chip>
    </Tooltip>
  );
};

export default StaffOnlyTag;
